export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zm1.61-9.977L8.425 3.28a.464.464 0 00-.853 0L6.39 6.023l-2.97.283a.464.464 0 00-.263.81l2.238 1.98-.65 2.921a.464.464 0 00.69.5L8 10.996l2.564 1.521a.464.464 0 00.69-.5l-.65-2.92 2.238-1.982a.463.463 0 00-.263-.81l-2.97-.282z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};